import { NgClass } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'button-badge',
    imports: [
      NgClass
    ],
    templateUrl: './button-badge.component.html',
    styleUrl: './button-badge.component.scss'
})
export class ButtonBadgeComponent {
  @ViewChild('content') content!: ElementRef;
  @Input() type: 'primary'|'default' = 'default' ;
  @Input() icon: string = 'bi-bell-fill';
  @Input() badge: number = 0;
  @Input() active: boolean = true;
  @Input() dropdown: boolean = false;
  @Input() width: number = 15;
  show: boolean = false;

  preventDefaults(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
  close() {
    this.show = false;
  }
  toggle(event: Event) {
    this.show = !this.show;
  }

  @HostListener('document:mousedown', ['$event'])
  onClickAway(event: MouseEvent) {
    if (!this.content.nativeElement.contains(event.target)) {
     this.show = false;
    }
  }
}
